// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Atom_Text from "../../atom/Atom_Text.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_String from "../../../type/Type_String.bs.js";

function Organism_Teaser_Subtitle(Props) {
  var id = Props.id;
  var identifier = Props.identifier;
  var subtitle = Props.subtitle;
  var style = Props.style;
  var kindOpt = Props.kind;
  var kind = kindOpt !== undefined ? kindOpt : "h4";
  var match = Belt_Option.map(subtitle, Type_String.Teaser.Subtitle.toString);
  if (match === undefined) {
    return null;
  }
  if (match === "") {
    return null;
  }
  if (style === undefined) {
    return React.createElement(Atom_Text.ScreenreadersLabel.make, {
                children: match
              });
  }
  var tmp = {
    children: match,
    kind: kind,
    style: style
  };
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (identifier !== undefined) {
    tmp.identifier = Caml_option.valFromOption(identifier);
  }
  return React.createElement(Atom_Text.make, tmp);
}

var make = Organism_Teaser_Subtitle;

export {
  make ,
}
/* react Not a pure module */
